
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/designsystem",
      function () {
        return require("private-next-pages/services/designsystem.tsx");
      }
    ]);
  